
import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-flashlight-line',
      title: t('services.electrical.title'),
      description: t('services.electrical.description'),
      image: 'https://public.readdy.ai/ai/img_res/83ff41a8213bace118bd05de9a515e8f.jpg'
    },
    {
      icon: 'ri-wifi-line',
      title: t('services.networking.title'),
      description: t('services.networking.description'),
      image: 'https://readdy.ai/api/search-image?query=Advanced%20networking%20infrastructure%20installation%20with%20fiber%20optic%20cables%20and%20server%20equipment%20in%20a%20modern%20office%20building%20in%20Saudi%20Arabia%20with%20professional%20cable%20management%20and%20clean%20setup&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-temp-cold-line',
      title: t('services.hvac.title'),
      description: t('services.hvac.description'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20HVAC%20system%20installation%20with%20air%20conditioning%20units%20and%20ventilation%20ducts%20in%20a%20premium%20commercial%20space%20in%20Saudi%20Arabia%20with%20energy%20efficient%20equipment%20and%20smart%20controls&width=400&height=300&seq=service3&orientation=landscape'
    },
    {
      icon: 'ri-tv-2-line',
      title: t('services.digitalsignage.title'),
      description: t('services.digitalsignage.description'),
      image: 'https://readdy.ai/api/search-image?query=Interactive%20digital%20signage%20displays%20and%20LED%20screens%20installation%20in%20a%20modern%20Saudi%20Arabian%20commercial%20building%20with%20sleek%20mounting%20and%20professional%20setup&width=400&height=300&seq=service4&orientation=landscape'
    },
    {
      icon: 'ri-volume-up-line',
      title: t('services.audiovisual.title'),
      description: t('services.audiovisual.description'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20audio%20visual%20equipment%20installation%20with%20sound%20systems%20and%20video%20conferencing%20setup%20in%20a%20contemporary%20Saudi%20Arabian%20office%20space%20with%20modern%20technology%20integration&width=400&height=300&seq=service5&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: t('services.construction.title'),
      description: t('services.construction.description'),
      image: 'https://readdy.ai/api/search-image?query=Complete%20interior%20fitout%20construction%20work%20in%20progress%20in%20a%20luxury%20Saudi%20Arabian%20commercial%20space%20with%20workers%20installing%20premium%20finishes%2C%20lighting%2C%20and%20modern%20design%20elements&width=400&height=300&seq=service6&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('services.title')} <span className="text-[#FE5000]">{t('services.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="w-12 h-12 bg-[#FE5000]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-[#FE5000] text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
